import dayjs from "dayjs";

import { useTranslation } from "@/core/i18n";

import { Models } from "api/types";
import { formatCurrency } from "toolbox/Money";

export interface RepeatCashActivityDetailsCardProps {
  transaction: Models<"DisplayRepeatCashTransactionForPerson"> | undefined;
  fallbackLocationName: string | null | undefined;
}

export const RepeatCashActivityDetailsCard = ({
  transaction,
  fallbackLocationName,
}: RepeatCashActivityDetailsCardProps) => {
  const { t } = useTranslation();
  const isAdded = transaction?.transactionType == "CashAdded";
  const isExpired = transaction?.transactionType == "CashExpired";

  let reasonHeader = t("repeatCashActivityDetailsPage.deductionReasonHeader");
  let amountLabel = t("repeatCashActivityDetailsPage.repeatCashDeductedLabel");
  let reason = transaction?.reason || transaction?.activityDescription;
  if (isAdded) {
    reasonHeader = t("repeatCashActivityDetailsPage.additionReasonHeader");
    amountLabel = t("repeatCashActivityDetailsPage.repeatCashAddedLabel");
  } else if (isExpired) {
    reasonHeader = t("repeatCashActivityDetailsPage.expiredReasonHeader");
    amountLabel = t("repeatCashActivityDetailsPage.repeatCashExpiredLabel");
    reason = t("repeatCashActivityDetailsPage.expiredExplanation");
  }

  return (
    <div className="flex flex-col gap-5 rounded-lg bg-white px-7 py-6 shadow-subtle">
      <div className="flex flex-col gap-2 border-b-[1px] border-b-light-grey pb-5">
        <div className="mb-2 flex items-center gap-1 text-body2">
          <span className="text-bold1">{t("repeatCashActivityDetailsPage.transactionLabel")}</span>
          {transaction?.id.split("-").pop()}
        </div>
        <div className="flex items-center gap-1 text-body2">
          <span className="text-bold2">{t("repeatCashActivityDetailsPage.dateLabel")} </span>
          {dayjs(transaction?.created).format("MM/DD/YY")}
        </div>
        <div className="flex items-center gap-1 text-body2">
          <span className="text-bold2">{t("repeatCashActivityDetailsPage.locationLabel")} </span>
          {transaction?.clientLocation || fallbackLocationName}
        </div>
        <div className="flex items-center gap-1 text-body2">
          <span className="text-bold2">{amountLabel} </span>
          {isAdded ? "" : "-"}
          {formatCurrency(transaction?.amountInCents ?? 0)}
        </div>
      </div>
      <div className="flex flex-col gap-3">
        <div className="text-bold3 uppercase">{reasonHeader}</div>
        <div className="text-body2">{reason}</div>
      </div>
    </div>
  );
};
